          
    class FreeShippingCalculator {
      constructor(root) {
        this.root = root;
        this.threshold = Number(root.dataset.threshold) || 15000;
        this.timeElement = this.getOrCreateTimeElement();

        if (!this.timeElement) return;

        document.addEventListener("rebuy:cart.change", () => this.init());
        document.addEventListener("rebuy:cart.ready", () => this.init());
        document.addEventListener("customCart:event", (e) => this.update(e.detail.cart));

        this.init();
      }

      getOrCreateTimeElement() {
        let timeElement = this.root.querySelector(".countdown__time");
        if (timeElement) return timeElement;

        timeElement = document.createElement("span");
        timeElement.className = "countdown__time";

        const labels = this.root.querySelectorAll(".countdown__label");
        if (labels.length > 1) {
          labels[0].after(timeElement);
        } else {
          this.root.appendChild(timeElement);
        }

        return timeElement;
      }

      async init() {
        try {
          const res = await fetch("/cart.js");
          const cart = await res.json();
          cart ? this.update(cart) : this.showFallback();
        } catch (e) {
          this.showFallback();
        }
      }

      getRemaining(cart) {
        const subtotal =
          cart?.items_subtotal_price ??
          cart?.subtotal_price ??
          cart?.subtotal ??
          cart?.cart?.items_subtotal_price ??
          cart?.cart?.subtotal_price ??
          0;
        return this.threshold - subtotal;
      }

      formatMoney(cents) {
        return `$${(cents / 100).toFixed(2)}`;
      }

      showFallback() {
        this.root.querySelectorAll(".countdown__label").forEach(el => el.textContent = "");
        this.timeElement.textContent = "Spend $150 & Get Free Shipping*";
        this.timeElement.style.color = "inherit";
        this.root.classList.remove("is-unlocked");
        this.root.classList.add("loaded");
      }

      hasSubscription(cart) {
        return cart?.items?.some(item => item.selling_plan_allocation != null);
      }

      update(cart) {
        if (!cart) return this.showFallback();
      if (this.hasSubscription(cart)) {
        this.root.querySelectorAll(".countdown__label").forEach(el => el.textContent = "");
        this.timeElement.innerHTML = "<span class=\"free-word\">Free Shipping* </span>on your subscription order!";
        this.timeElement.style.color = "";
        this.root.classList.add("is-unlocked");
        this.root.classList.add("loaded");
        return;
      }
        const remaining = this.getRemaining(cart);

        if (remaining <= 0) {
          this.root.querySelectorAll(".countdown__label").forEach(el => el.textContent = "");
          this.timeElement.innerHTML = "You get <span class=\"free-word\">FREE</span> shipping in all U.S*";
          this.timeElement.style.color = "";
          this.root.classList.add("is-unlocked");
        } else if (remaining >= this.threshold) {
          this.root.classList.remove("is-unlocked");
          this.showFallback();
        } else {
          this.root.classList.remove("is-unlocked");
          this.root.querySelectorAll(".countdown__label").forEach((el, i) => {
            el.textContent = i === 0 ? "You're\u00a0" : "\u00a0away from free shipping*";
          });
          this.timeElement.textContent = this.formatMoney(remaining);
          this.timeElement.style.color = "";
        }

        this.root.classList.add("loaded");
      }
    } 

    const freeShippingWidgets = new WeakSet();

    const mountFreeShippingWidgets = (scope = document) => {
      scope.querySelectorAll(".free-shipping").forEach((el) => {
        if (freeShippingWidgets.has(el)) return;
        freeShippingWidgets.add(el);
        new FreeShippingCalculator(el);
      });
    };

    mountFreeShippingWidgets();
    document.addEventListener("rebuy:cart.ready", () => mountFreeShippingWidgets());
    document.addEventListener("rebuy:smartcart.ready", () => mountFreeShippingWidgets());

    const freeShippingObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches(".free-shipping")) {
            mountFreeShippingWidgets(node.parentElement || document);
            return;
          }
          if (node.querySelector && node.querySelector(".free-shipping")) {
            mountFreeShippingWidgets(node);
          }
        });
      });
    });

    freeShippingObserver.observe(document.body, { childList: true, subtree: true });
